// extracted by mini-css-extract-plugin
export default {"closeBtn":"SelectedPanel_closeBtn__9ESGj","closeIcon":"SelectedPanel_closeIcon__voDIV","item":"SelectedPanel_item__iLSYb","list":"SelectedPanel_list__bxgCM"};